module.exports = __webpack_public_path__ + "img/remotelab-concept.58076bb3.png";